/* Create Vue 3 App */
import "@/assets/styles/main.scss";

import config from "./config";

async function loadStyle() {
	await import(`@/assets/styles/${config.ORIGIN.toLowerCase()}/theme.scss`);
}

loadStyle().then(() => {
	console.log("CSS loaded");
});

import {createApp} from "vue";
import App from "./App.vue";

const app = createApp(App);

/* App use Vuex Store */
import store from "./store";

app.use(store);

/* App use Vuetify */
import vuetify from "@/plugins/vuetify";

app.use(vuetify);

/* App use Perfect Scrollbar plugin */
import PerfectScrollbar from "vue3-perfect-scrollbar";

app.use(PerfectScrollbar);

import WorkerTimer from "@/plugins/WorkerTimer";

app.config.globalProperties.$worker = WorkerTimer;

// Set favicon
let link = document.querySelector("link[rel~='icon']");
if (!link) {
	link = document.createElement("link");
	link.rel = "icon";
	document.head.appendChild(link);
}
link.href = `/${config.ORIGIN.toLowerCase()}-favicon.ico`;

/* Mount App */
app.mount("#app");